import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
} from '@mui/material'
import { useContext, useMemo, useState } from 'react'
import { useLazyGetFileQuery, useLazyGetMedComplexByIdQuery } from '@/api'
import {
  DownloadIcon,
  SplitWindowIcon,
  TetronLogo,
  UpdateIcon,
  WindowIcon,
} from './icons'
import { styles } from './styles'
import { Accordion, AccrodionControl } from '../../components'
import { MedComplexContext } from '../../MedComplex'

export const LogInfo = () => {
  const { medcomplex, refetch } = useContext(MedComplexContext)
  const [getFile] = useLazyGetFileQuery()
  const [splitWindow, setSplitWindow] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [logs, setLogs] = useState<string[]>()

  const handleSplitWindow = () => {
    setSplitWindow((prev) => !prev)
  }

  const handleUpdateLogs = () => {
    setLoading(true)
    refetch().then(() => {
      getFullLogs()
      setLoading(false)
    })
  }

  const getFullLogs = async () => {
    if (medcomplex?.info?.length > 0) {
      Promise.all(
        medcomplex.info.map(
          async (file: string) => await getFile(file).unwrap()
        )
      ).then((response) => {
        Promise.all(
          response?.map(
            async (blob: string) =>
              await fetch(blob).then(async (r) => await r.text())
          )
        ).then((result) => {
          if (result) {
            setLogs(result)
          }
        })
      })
    }
  }

  useMemo(async () => {
    getFullLogs()
  }, [])

  const [alignment, setAlignment] = useState<string>('log_1')

  const handleChangeTab = (
    _: React.MouseEvent<HTMLElement>,
    newAlignment: string
  ) => {
    if (newAlignment) {
      setAlignment(newAlignment)
    }
  }

  return (
    <Stack gap={'8px'} height={'566px'}>
      <Box sx={{ marginLeft: 'auto' }}>
        <Stack direction={'row'} gap={'12px'}>
          <a
            // href={window.location.origin + '/public/pdf/exchange_protocol.pdf'}
            href={'/pdf/exchange_protocol.pdf'}
            download="Протокол обмена медтерминал.pdf"
          >
            <Button variant="outlined">
              <Stack direction={'row'} gap={'4px'} mb="-4px">
                <DownloadIcon />
                Описание протокола обмена
              </Stack>
            </Button>
          </a>
          <Button variant="contained" onClick={handleUpdateLogs}>
            <Stack direction={'row'} gap={'4px'} mb="-4px">
              <UpdateIcon />
              Обновить
            </Stack>
          </Button>
        </Stack>
      </Box>
      <Accordion
        title={
          <Stack direction={'row'} gap={'16px'} alignItems={'center'}>
            <TetronLogo />
            <ToggleButtonGroup
              sx={styles.toggleButtonsGroup}
              color="primary"
              value={alignment}
              exclusive
              onChange={handleChangeTab}
            >
              <ToggleButton size={'large'} value={'log_1'}>
                <Stack direction={'row'} gap={'8px'} alignItems={'center'}>
                  Лог №1
                </Stack>
              </ToggleButton>
              <ToggleButton size={'large'} value={'log_full'}>
                <Stack direction={'row'} gap={'8px'} alignItems={'center'}>
                  Полный лог
                </Stack>
              </ToggleButton>
            </ToggleButtonGroup>
          </Stack>
        }
        buttons={
          <Stack direction={'row'} alignItems={'center'}>
            <Tooltip
              arrow
              placement="top"
              title={`${splitWindow ? 'Одно' : 'Разделить'} окно`}
            >
              <Box>
                <AccrodionControl onClick={handleSplitWindow}>
                  {splitWindow ? <WindowIcon /> : <SplitWindowIcon />}
                </AccrodionControl>
              </Box>
            </Tooltip>
          </Stack>
        }
        hideExpandButton={true}
        defaultExpanded
      >
        {loading ? (
          <Box sx={styles.loading}>
            <Stack alignItems={'center'} gap={'16px'}>
              Загрузка логов
              <CircularProgress sx={{ scale: '1.3' }} />
            </Stack>
          </Box>
        ) : (
          <Stack sx={{ ...styles.container, ...styles.scrollBar }}>
            <Box sx={styles.collapse}>
              <Box sx={styles.field}>
                <Box sx={{ ...styles.content, ...styles.pre }}>
                  {medcomplex?.logs && alignment === 'log_1'
                    ? medcomplex.logs.slice().map(
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        (item: any) => (
                          <>
                            {`${item.type} ${item.dateTime}`}
                            <br />
                            <Box ml={2}>{`${item.log}`}</Box>
                            <br />
                          </>
                        )
                      )
                    : ''}
                  {alignment === 'log_full'
                    ? logs?.map((text, index) => (
                        <>
                          {/* {index === 0 ? null : <br />} */}
                          {text}
                        </>
                      ))
                    : ''}
                </Box>
              </Box>
            </Box>
            <Divider
              variant="fullWidth"
              sx={{
                border: splitWindow ? '6px solid #EEE' : '0px solid #EEE',
                transition: 'border 0.3s ease-out',
              }}
            />
            <Box
              sx={{
                ...styles.collapse,
                flexBasis: splitWindow ? '50em' : '0em',
              }}
            >
              <Box sx={styles.field}>
                <Box sx={{ ...styles.content, ...styles.pre }}>
                  {medcomplex?.logs && alignment === 'log_1'
                    ? medcomplex.logs
                        .slice()
                        .reverse()
                        .map(
                          // eslint-disable-next-line @typescript-eslint/no-explicit-any
                          (item: any) => (
                            <>
                              {`${item.type} ${item.dateTime}`}
                              <br />
                              <Box ml={2}>{`${item.log}`}</Box>
                              <br />
                            </>
                          )
                        )
                    : ''}
                  {alignment === 'log_full'
                    ? logs?.map((text, index) => (
                        <>
                          {/* {index === 0 ? null : <br />} */}
                          {text}
                        </>
                      ))
                    : ''}
                </Box>
              </Box>
            </Box>
          </Stack>
        )}
      </Accordion>
    </Stack>
  )
}
